module.exports = __webpack_public_path__ + "img/framboise_snit.7b86af54.jpg";